import { render } from "./component-egr-view-button-new.vue?vue&type=template&id=c34a2c44"
import script from "./component-egr-view-button-new.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egr-view-button-new.vue?vue&type=script&setup=true&lang=js"

import "./component-egr-view-button-new.vue?vue&type=style&index=0&id=c34a2c44&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-card/field-wrappers/component-egr-view-button-new.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c34a2c44"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c34a2c44', __exports__)) {
    api.reload('c34a2c44', __exports__)
  }
  
  module.hot.accept("./component-egr-view-button-new.vue?vue&type=template&id=c34a2c44", () => {
    api.rerender('c34a2c44', render)
  })

}


export default __exports__